import { render, staticRenderFns } from "./QuickReplyPopup.vue?vue&type=template&id=31d61ae6"
import script from "./QuickReplyPopup.vue?vue&type=script&lang=js"
export * from "./QuickReplyPopup.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyPopup.vue?vue&type=style&index=0&id=31d61ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports